const datas = [
  { name: 'اسم', age: 'العمر', city: 'المدينة' },
  { name: 'أحمد', age: 25, city: 'القاهرة' },
  { name: 'مريم', age: 30, city: 'دبي' },
];


// handle CSV file exporting
export const convertToCSV = (data) => {
  const array = [Object.keys(data[0])].concat(data);

  return array.map(row => {
    return Object.values(row)
      .map(value => {
        // If the value contains a comma, newline, or quote, enclose it in double quotes
        if (typeof value === 'string' && (value.includes(',') || value.includes('\n') || value.includes('"'))) {
          value = `"${value.replace(/"/g, '""')}"`; // Escape any double quotes inside the value
        }
        return value;
      })
      .join(',');
  }).join('\n');
};


export const downloadCSV = (data, filename) => {
  const csv = convertToCSV(data);
  // Adding BOM for UTF-8 encoding
  const bom = "\uFEFF";
  const blob = new Blob([bom + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${filename}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const adjustToLocalDate = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return localDate.toISOString().split('T')[0];
};